import { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { Flag } from 'lucide-react';
import ContentReportModal from '@/modules/content/common/ContentReportModal';
import { TContentReportReason } from '@/types/Content.types';

const ReportMenu = ({ onReport }: { onReport: (reason: TContentReportReason, note?: string) => Promise<void> }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <HStack
        as="button"
        type="button"
        aria-label="Report"
        onClick={() => setIsOpen(true)}
        justify="center"
        width="48px"
        height="48px"
        borderRadius="full"
        cursor="pointer"
        backgroundColor="white"
        color="text.mediumBlue"
        boxShadow="0px 4px 14px rgba(14, 0, 98, 0.10)"
        transition="all 0.15s ease"
        _hover={{ transform: 'translateY(-2px)', color: 'primary.500' }}
      >
        <Flag size={20} strokeWidth={2} />
      </HStack>
      <ContentReportModal isOpen={isOpen} onClose={() => setIsOpen(false)} onReport={onReport} />
    </>
  );
};

export default ReportMenu;
